/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Menu/Item.ts" />
namespace HA.Core.Controller.Menu {
    import Item = HA.Core.HTML.Menu.Item;
    export class MenuItem extends Controller {
        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            if (! data.has("no-init")) {
                this.addToData( "tag", new Item(data));
            }
        }
    }
}
